import { ScrollDrivenContainer } from "./setup-demo";

export const SetupSection = () => {
  return (
    <section className="relative">
      {/* Scroll-Driven Interactive Demo - includes title inside sticky container */}
      <ScrollDrivenContainer
        title="Set up in minutes"
        description="Connect your business data automatically. No manual entry, no complicated configuration."
        subdescription="Everything syncs seamlessly in the background."
      />

      {/* CSS animations */}
      <style>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};
